import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

const config = JSON.parse(process.env.APP_CONFIG);
if (!process.env.CI) {
    GoogleAnalytics.initialize(config.REACT_APP_GOOGLE_ANALYTICS);
}

const withTracker = (WrappedComponent, options = {}) => {
    const trackPage = page => {
        if (!process.env.CI) {
            GoogleAnalytics.set({
                page,
                ...options
            });
            GoogleAnalytics.pageview(page);
        }
    };

    // eslint-disable-next-line
    const HOC = class extends Component {
        componentDidMount() {
            // eslint-disable-next-line
            const { location } = this.props;
            const page = location.pathname + location.search;
            trackPage(page);
        }

        componentDidUpdate(prevProps) {
            const currentPage = prevProps.location.pathname + prevProps.location.search;
            const { location } = this.props;
            const nextPage = location.pathname + location.search;

            if (currentPage !== nextPage) {
                trackPage(nextPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return HOC;
};

export default withTracker;
